module.exports = __webpack_public_path__ + "img/24.a919427e.jpg";